<template>
    <Menu as="div" class="relative flex-shrink-0">
        <div>
            <MenuButton
                class="p-1 rounded-full flex text-sm text-white hover:bg-minplan-lightgrey focus:outline-none">
                <ServerIcon class="h-6 w-6" aria-hidden="true" />
            </MenuButton>
        </div>
        <transition enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95">

            <MenuItems
                class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                <MenuItem v-for="item in navigation" :key="item.name" v-slot="{ active }">
                    <Link :href="item.href"
                          :method="item.method"
                          as="button"
                          class="w-full justify-start text-left"
                          :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">
                        {{
                            $t(item.name)
                        }}
                    </Link>
                </MenuItem>
            </MenuItems>

        </transition>
    </Menu>

</template>

<script>
import { ServerIcon } from "@heroicons/vue/outline";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { Link } from "@inertiajs/inertia-vue3";

const adminNavigation = [
    { name: "navigation.agencies", href: route("admin.agencies.index"), method: "get" }
];

export default {
    name: "UserNavigationDropdown",
    props: ["isAdmin"],
    components: {
        ServerIcon,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        Link
    },
    setup(props) {
        return {
            navigation: adminNavigation
        };
    }
};
</script>

<style scoped>

</style>
